"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var moment = require("moment");
var base_1 = require("@bhtp-client-api/base");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var validators_1 = require("./../validators");
var view_models_1 = require("./../view-models");
var misc_1 = require("./../misc");
var blocked_provider_helper_1 = require("./../blocked-provider.helper");
var FlightBuilderComponent = (function () {
    function FlightBuilderComponent(eligibilityService, modalService) {
        this.eligibilityService = eligibilityService;
        this.modalService = modalService;
        this.isEdit = false;
        this.validationOverride = false;
        this.acknowledgementsAccepted = new core_1.EventEmitter();
        this.productSwapRequested = new core_1.EventEmitter();
        this.requoteFlights = new core_1.EventEmitter();
        this.blockedProvidersClicked = new core_1.EventEmitter();
        this.maxFlights = 4;
    }
    FlightBuilderComponent.prototype.ngOnChanges = function (changes) {
        if (changes['forms'] && this.flights && this.package && this.forms && !this.formInitialized) {
            this.buildForm();
        }
    };
    FlightBuilderComponent.prototype.buildForm = function () {
        var _this = this;
        // Check if this.maxDate is set when we initialize the form, if it was, we don't want to override it
        var maxDatePassedIn = Boolean(this.maxDate);
        // set the maximum number of flights from the package configuration,
        // and track if flights are required
        if (this.package && this.package.configuration) {
            if (this.package.configuration.maximumNumberFlightsTotal) {
                this.maxFlights = this.package.configuration.maximumNumberFlightsTotal;
            }
            this.flightsRequired = base_1.ApiPackageConfiguration.requiresFlights(this.package.configuration);
        }
        this.flights.forEach(function (f) {
            _this.forms.push(new forms_1.FormGroup({}));
        });
        this.forms.valueChanges.debounceTime(100).subscribe(function (flights) {
            if (!maxDatePassedIn) {
                _this.maxDate = _this.getMaxDateForFlights((_this.tripDepartureDate ? _this.tripDepartureDate.localized.dateString : null), _this.package.configuration.maximumTripLength, flights);
            }
            _this.showRequiredError = _this.shouldShowRequiredError();
        });
        this.formInitialized = true;
    };
    FlightBuilderComponent.prototype.onAddFlight = function () {
        if (this.flights.length < this.maxFlights) {
            this.flights.push(new view_models_1.FlightViewModel());
            this.forms.push(new forms_1.FormGroup({}));
            // see if adding this flight requires a requote
            this.checkForRequote(false);
        }
    };
    FlightBuilderComponent.prototype.onRemoveFlight = function (index) {
        this.flights.splice(index, 1);
        // remove any acknowledgements for the flight
        var flight = this.forms.at(index).value;
        this.onAcknowledgementsCleared(misc_1.AcknowledgementService.getAcknowledgementsForFlight(flight, this.acknowledgements));
        this.forms.removeAt(index);
        // see if removing this flight still exceeds the included flight count
        this.checkForRequote(true);
    };
    FlightBuilderComponent.prototype.onAcknowledgementsCleared = function (acknowledgements) {
        var _this = this;
        // if a flight is removed, remove any acknowledgements that go with the flight
        acknowledgements.forEach(function (ack) {
            var index = _this.acknowledgements.findIndex(function (a) { return a.typeIdentifier === ack.typeIdentifier &&
                a.coverages === ack.coverages; });
            if (index >= 0) {
                _this.acknowledgements.splice(index, 1);
            }
        });
        this.acknowledgementsAccepted.emit(this.acknowledgements);
    };
    FlightBuilderComponent.prototype.checkAllFlights = function () {
        var _this = this;
        // gather information for flight eligibility
        var flightsToSend = this.getFlightsForRequest();
        var packageRatingId = this.package.ratingId;
        var apiTravelers = this.getRequestTravelers();
        // Send flights to eligibility
        if (!this.isEdit) {
            this.modalService.showLoadingModal('Checking flights...');
        }
        return this.eligibilityService.verifyFlightsByPackageWithRecommendations(flightsToSend, apiTravelers, this.acknowledgements, packageRatingId, this.tripDepartureDate, this.tripReturnDate, this.eligibilityToken)
            .finally(function () {
            if (!_this.isEdit) {
                _this.modalService.hideLoadingModal();
            }
        })
            .map(function (data) {
            return _this.handleEligibilityResponse(data);
        }, function (err) {
            return false;
        });
    };
    FlightBuilderComponent.prototype.shouldShowRequiredError = function () {
        // if flights are required and user tried to continue with no valid flights, show required flights message
        return this.package.configuration.flightRequirementType !== base_1.FlightRequirementTypes.conditional && this.flightsRequired && this.submitted && this.forms.invalid && this.forms.controls.length === 1;
    };
    FlightBuilderComponent.prototype.onBlockedProviderLinkClicked = function () {
        this.blockedProvidersClicked.emit();
    };
    FlightBuilderComponent.prototype.showEventLink = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.showEventLink(this.baseUrl);
    };
    FlightBuilderComponent.prototype.showHrefLink = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.showHrefLink(this.baseUrl);
    };
    FlightBuilderComponent.prototype.getBlockedProviderUrl = function () {
        return blocked_provider_helper_1.BlockedProviderHelper.getBlockedProviderUrl(this.baseUrl);
    };
    FlightBuilderComponent.prototype.setFormInitializedToFalse = function () {
        this.formInitialized = false;
    };
    FlightBuilderComponent.prototype.getMaxDateForFlights = function (departureDateString, maxTripLength, flights) {
        var maxDateString;
        var departureDate = moment(departureDateString, validators_1.Constants.DATE_PARSE_FORMAT);
        if (departureDate.isValid()) {
            // If there is a valid departure date, that should be our "start" date for the max trip span
            maxDateString = getMaxDateRelativeToEarlyDate(departureDate, maxTripLength);
        }
        else if (maxTripLength >= 0) {
            // If we didn't have a departure date to use as our trip start, we need to find the earliest flight
            // and consider that the start of the trip.
            var earliestDateString_1;
            flights.forEach(function (flight) {
                var flightDate = moment(flight.flightDate, validators_1.Constants.DATE_PARSE_FORMAT);
                if (!earliestDateString_1) {
                    // Mark the first valid flight depature we find as the earliest
                    if (flightDate.isValid()) {
                        earliestDateString_1 = flight.flightDate;
                    }
                }
                else {
                    // For each additional valid flight departure found, compare to see if it's lower than what we've seen already
                    var earliestDate = moment(earliestDateString_1, validators_1.Constants.DATE_PARSE_FORMAT);
                    if (earliestDate.isValid() && flightDate.isValid() && flightDate.isBefore(earliestDate)) {
                        earliestDateString_1 = flight.flightDate;
                    }
                }
            });
            // If we found the earliest valid flight departure date, use that as the start of our trip
            var maxDate = moment(earliestDateString_1, validators_1.Constants.DATE_PARSE_FORMAT);
            if (maxDate.isValid()) {
                maxDateString = getMaxDateRelativeToEarlyDate(maxDate, maxTripLength);
            }
        }
        return maxDateString;
        function getMaxDateRelativeToEarlyDate(earlyDate, maxTripLength) {
            return earlyDate.add(maxTripLength, 'days').format(validators_1.Constants.DATE_PARSE_FORMAT);
        }
    };
    FlightBuilderComponent.prototype.handleEligibilityResponse = function (data) {
        var _this = this;
        if (data) {
            // collect any errors messages from the response, or on individual flights
            var messages_1 = [];
            if (data.flights && data.flights.some(function (f) { return f.flightMessage && f.flightMessage.length > 0; })) {
                data.flights.forEach(function (f) {
                    if (f.flightMessage && f.flightMessage.length > 0) {
                        f.flightMessage.forEach(function (m) {
                            messages_1.push(m);
                        });
                    }
                });
            }
            if (data.messages && data.messages.length > 0) {
                data.messages.forEach(function (m) {
                    messages_1.push(m);
                });
            }
            // if there were any messages, display them in a modal. This will take
            // care of acknowledgements / flight swap errors
            if (messages_1.length > 0) {
                // using timeout to display modal so that the correct style gets applied, there is a race condition
                // that happens when hidding a modal then showing another one right after
                setTimeout(function () { _this.showErrorModal(messages_1, data.flights); }, 500);
            }
            else if (data.allFlightsEligible) {
                this.updateAcceptedAcknowledgements(data.updatedAcknowledgements);
                return true;
            }
        }
        return false;
    };
    FlightBuilderComponent.prototype.showErrorModal = function (messages, responseFlights) {
        var _this = this;
        var options = new misc_1.ModalOptions();
        options.title = 'Eligibility Check Failed';
        options.apiErrorMessages = messages;
        options.availablePackages = this.availablePackages;
        // the modal can return information about accepted acks, and
        // product swaps, so respond to what it returns upon closing
        this.modalService.showApiMessageModal(options).subscribe(function (data) {
            _this.handleMessageModalCompletion(data, responseFlights);
        });
    };
    FlightBuilderComponent.prototype.handleMessageModalCompletion = function (data, responseFlights) {
        var _this = this;
        // a recommendation was made and accepted by the user to change the
        // product. Let parent components respond to the swap
        if (data.ratingIdToSwap) {
            this.productSwapRequested.emit(data.ratingIdToSwap);
        }
        if (data.acceptedAcknowledgements && data.acceptedAcknowledgements.length > 0) {
            // track the acknowledgements that have been accepted
            if (!this.acknowledgements) {
                this.acknowledgements = new Array();
            }
            this.acknowledgements = this.acknowledgements.concat(data.acceptedAcknowledgements);
            // rerun eligiblity to acknowledge the eligiblity errors
            this.checkAllFlights().subscribe(function (success) {
                if (success) {
                    _this.acknowledgementsAccepted.emit(_this.acknowledgements);
                }
            });
        }
    };
    FlightBuilderComponent.prototype.updateAcceptedAcknowledgements = function (acks) {
        var _this = this;
        if (acks) {
            acks.forEach(function (ack) {
                // find the original acknowledgement and replace it with the updated one
                var index = _this.acknowledgements.findIndex(function (a) { return a.typeIdentifier === ack.typeIdentifier &&
                    a.relatedTypeIdentifier === ack.relatedTypeIdentifier && a.coverages.every(function (c) { return ack.coverages.indexOf(c) >= 0; }); });
                if (index >= 0) {
                    _this.acknowledgements[index] = ack;
                }
            });
            this.acknowledgementsAccepted.emit(this.acknowledgements);
        }
    };
    FlightBuilderComponent.prototype.checkForRequote = function (isRemoval) {
        // if the included flight threshold was exceeded, requote with each flight change.
        // if removing flights, requote at the threshold as well
        if (this.package && this.package.configuration && this.package.configuration.baseIncludedFlights >= 0) {
            if ((!isRemoval && this.flights.length > this.package.configuration.baseIncludedFlights) ||
                (isRemoval && this.flights.length >= this.package.configuration.baseIncludedFlights)) {
                this.requoteFlights.emit(this.flights.length);
            }
        }
    };
    FlightBuilderComponent.prototype.getRequestTravelers = function () {
        var apiTravelers = new Array();
        this.travelers.forEach(function (t) {
            var apiTraveler = view_models_1.TravelerDetailViewModel.toApiTraveler(t);
            apiTravelers.push(apiTraveler);
        });
        return apiTravelers;
    };
    FlightBuilderComponent.prototype.getFlightsForRequest = function () {
        var flightsToCheck = this.getFlightsFromForm();
        // Convert view models into eligibility request
        var flightsToSend = [];
        flightsToCheck.forEach(function (f, index) {
            var apiFlight = view_models_1.FlightViewModel.toApiFlight(f, index);
            flightsToSend.push(apiFlight);
        });
        return flightsToSend;
    };
    FlightBuilderComponent.prototype.getFlightsFromForm = function () {
        // Select only flights that contain all data points for eligibility
        var flightsToCheck = new Array();
        for (var i = 0; i < this.forms.controls.length; i++) {
            var flight = this.forms.at(i);
            var flightToCheck = flight.value;
            // only validate or add the flight if it is not empty
            if (!view_models_1.FlightViewModel.isEmpty(flightToCheck) && flight.valid) {
                flightsToCheck.push(flightToCheck);
            }
        }
        return flightsToCheck;
    };
    return FlightBuilderComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightBuilderComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormArray)
], FlightBuilderComponent.prototype, "forms", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightBuilderComponent.prototype, "flights", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightBuilderComponent.prototype, "travelers", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", base_1.ApiPackage)
], FlightBuilderComponent.prototype, "package", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightBuilderComponent.prototype, "availablePackages", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightBuilderComponent.prototype, "acknowledgements", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightBuilderComponent.prototype, "minDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightBuilderComponent.prototype, "maxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", base_1.DateInformation)
], FlightBuilderComponent.prototype, "tripDepartureDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", base_1.DateInformation)
], FlightBuilderComponent.prototype, "tripReturnDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightBuilderComponent.prototype, "eligibilityToken", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightBuilderComponent.prototype, "showBlockedProviders", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightBuilderComponent.prototype, "baseUrl", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightBuilderComponent.prototype, "isEdit", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], FlightBuilderComponent.prototype, "validationOverride", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightBuilderComponent.prototype, "acknowledgementsAccepted", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightBuilderComponent.prototype, "productSwapRequested", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightBuilderComponent.prototype, "requoteFlights", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightBuilderComponent.prototype, "blockedProvidersClicked", void 0);
FlightBuilderComponent = __decorate([
    core_1.Component({
        selector: 'flight-builder',
        template: "<div *ngIf=\"showBlockedProviders\">     <div class=\"blocked-providers\">         <a [href]=\"getBlockedProviderUrl()\" [hidden]=\"!showHrefLink()\"  target=\"_blank\">View Blocked Providers</a>         <a href=\"javascript:void(0)\" [hidden]=\"!showEventLink()\" (click)=\"onBlockedProviderLinkClicked($event)\">View Blocked Providers</a>     </div> </div> <div *ngIf=\"forms?.controls\">     <div id=\"flight-labels\" class=\"row\">         <div class=\"col-xs-11\">             <div class=\"form-group col-lg-3 visible-lg\"><label>Flight Date</label></div>             <div class=\"form-group col-lg-3 visible-lg\"><label>Airline</label></div>             <div class=\"form-group col-lg-3 visible-lg\"><label>Flight Number</label></div>             <div class=\"form-group col-lg-3 visible-lg\"><label>Departure Airport <span class=\"fa fa-long-arrow-right\"></span> Arrival Airport</label></div>         </div>     </div>     <div id=\"flight-form\" class=\"row\" *ngFor=\"let flightForm of forms?.controls; let i = index\">         <flight-input [form]=\"flightForm\"                         [flight]=\"flights[i]\"                         [submitted]=\"submitted\"                         [acknowledgements]=\"acknowledgements\"                         [minDate]=\"minDate\"                         [maxDate]=\"maxDate\"                         [required]=\"flightsRequired\"                         [validationOverride]=\"validationOverride\"                         (acknowledgementsCleared)=\"onAcknowledgementsCleared($event)\"                         class=\"col-xs-11\"></flight-input>         <a *ngIf=\"i > 0\" href=\"javascript:void(0)\" (click)=\"onRemoveFlight(i)\"><span class=\"fa fa-trash-o fa-2x icon-align-grid\"></span></a>     </div>      <div class=\"row\" *ngIf=\"showRequiredError\">         <span *ngIf=\"!isEdit\" class=\"help-block haserrorfieldlevel col-sm-12\">Flight information is required for {{package.displayName}}. Please add your flight or <a href=\"/dashboard\">Choose a Different Product</a></span>         <span *ngIf=\"isEdit\" class=\"help-block haserrorfieldlevel col-sm-12\">Flight information is required for {{package.displayName}}. Please add your flight(s)</span>     </div>     <div class=\"row\">         <div class=\"col-md-12\" *ngIf=\"forms?.controls.length < maxFlights\">             <a href=\"javascript:void(0)\" (click)=\"onAddFlight()\">                 <span class=\"fa fa-plus-circle icon-align-text\"></span> <span>Add Flight</span>             </a>         </div>     </div>     <div class=\"row\">         <div class=\"col-md-10\">             <p *ngIf=\"forms?.controls.length < maxFlights - 1\">{{package?.displayName}} allows {{maxFlights - forms.controls.length}} more flights.</p>             <p *ngIf=\"forms?.controls.length == maxFlights -1\">{{package?.displayName}} allows 1 more flight.</p>             <p *ngIf=\"forms?.controls.length == maxFlights\">{{package?.displayName}} allows up to {{maxFlights}} flights. You have reached your maximum flight submission. Have more flights to enter? You'll need to buy another policy.</p>         </div>     </div> </div>",
        styles: ["\n        .blocked-providers {\n            padding-top: 15px;\n            padding-bottom: 15px;\n        }\n    "]
    }),
    __metadata("design:paramtypes", [eligibility_1.BhtpEligibilityService, misc_1.ModalService])
], FlightBuilderComponent);
exports.FlightBuilderComponent = FlightBuilderComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-builder/flight-builder.component.js